import { useEffect, useRef, useState } from 'react';
import apiRequest from '../../api/request';
import { workedUrl } from './workedTime';

// Today's worked time for the people on the page, from the server (never remembered between visits: a punch has to show up).
// Asks once the list is known, again whenever the list or `reloadKey` changes, and every `everyMs` while the page is open and visible,
// so a person who punches out (or in) turns from a ticking timer into a finished time (or starts one) without a reload.
// A failed load never throws anything away: the last good answer stays, and `error` says the refresh did not work.
// `userIds` null = not known yet: nothing is asked (so the page makes ONE request, with the people, instead of one without them first).
export const useWorkedToday = (userIds, reloadKey = 0, { everyMs = 60 * 1000 } = {}) => {
  const [state, setState] = useState({ data: null, error: null, loading: false });
  const known = userIds !== null && userIds !== undefined;
  const key = [...new Set(userIds || [])].sort((a, b) => a - b).join(',');
  const seq = useRef(0);

  useEffect(() => {
    if (!known) return undefined;
    let cancelled = false;
    const load = () => {
      const mine = ++seq.current;
      return apiRequest({ url: workedUrl(key ? key.split(',').map(Number) : []), method: 'get' })
        .then((res) => {
          if (cancelled || mine !== seq.current) return;
          if (res?.status === 'success' && res.data && res.data.people) setState({ data: res.data, error: null, loading: false });
          else setState((s) => ({ data: s.data, error: res?.message || 'Could not load worked time', loading: false }));
        })
        .catch((err) => {
          if (cancelled || mine !== seq.current) return;
          setState((s) => ({ data: s.data, error: err?.response?.data?.message || 'Could not load worked time', loading: false }));
        });
    };
    setState((s) => ({ ...s, loading: s.data === null }));
    load();
    const id = everyMs ? setInterval(() => { if (typeof document === 'undefined' || document.visibilityState !== 'hidden') load(); }, everyMs) : null;
    return () => {
      cancelled = true;
      if (id) clearInterval(id);
    };
  }, [known, key, reloadKey, everyMs]);

  return state;
};

export default useWorkedToday;
